module.exports = __webpack_public_path__ + "img/diamondMagic.afd477f.jpg";